module.exports = __webpack_public_path__ + "d8ae3996da0cb3df7f0e48d2af581041.mtl";